// extracted by mini-css-extract-plugin
module.exports = {"label":"_2lH9h6DXJP_NMAzhosMcOf description","value":"_3cQpv7QpPl5I1fDArniy12"};